module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('pageTitle', {
    attrs: {
      "title": "选择城市"
    }
  }), _vm._v(" "), _c('mu-paper', {
    staticClass: "search-paper",
    attrs: {
      "zDepth": 1
    }
  }, [_c('mu-auto-complete', {
    staticClass: "inputCity",
    attrs: {
      "hintText": "输入城市名查询",
      "dataSource": _vm.nameDataSource,
      "icon": "search",
      "maxSearchResults": 10
    },
    on: {
      "change": _vm.handlechange
    }
  })], 1), _vm._v(" "), _c('mu-sub-header', {
    staticClass: "title"
  }, [_vm._v("当前城市")]), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "labelDiv",
    attrs: {
      "label": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleCitychange(_vm.LocationInfo)
      }
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "location_on"
    }
  }), _vm._v(_vm._s(_vm.LocationInfo.CityName) + "\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "divDivider"
  }), _vm._v(" "), _c('mu-sub-header', {
    staticClass: "title"
  }, [_vm._v("热门城市")]), _vm._v(" "), _vm._l((_vm.hotCity), function(item, key) {
    return _c('div', {
      staticClass: "hotTr",
      on: {
        "click": function($event) {
          return _vm.handleCitychange(item)
        }
      }
    }, [_c('div', {
      class: [key == _vm.hotCity.length - 1 ? 'hotTdLast' : 'hotTd' ]
    }, [_vm._v("\n            " + _vm._s(item.CityName) + "\n          ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "divDivider"
  }), _vm._v(" "), _c('mu-tabs', {
    staticClass: "kosmos-tabs",
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "tabFirst",
      "title": "国内城市"
    }
  }), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "tabSecond",
      "title": "海外城市"
    }
  })], 1), _vm._v(" "), (_vm.activeTab === 'tabFirst') ? _c('div', [_c('mu-sub-header', {
    staticClass: "title"
  }, [_vm._v("按字母排序")]), _vm._v(" "), _c('div', {
    staticClass: "letterDiv"
  }, _vm._l((_vm.cityByLetter), function(item, key) {
    return _c('div', {
      class: [key == _vm.cityByLetter.length - 1 ? 'letterLabelLast' : 'letterLabel' ],
      on: {
        "click": function($event) {
          return _vm.goAnchor('#anchor-' + item.Letter)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.Letter) + "\n            ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "divDivider"
  }), _vm._v(" "), _vm._l((_vm.cityByLetter), function(item) {
    return _c('div', {
      staticClass: "letterCity"
    }, [_c('mu-sub-header', {
      staticClass: "title",
      attrs: {
        "id": 'anchor-' + item.Letter
      }
    }, [_vm._v(_vm._s(item.Letter))]), _vm._v(" "), _vm._l((item.Citys), function(itemCity, key) {
      return _c('div', {
        staticClass: "cityTr",
        on: {
          "click": function($event) {
            return _vm.handleCitychange(itemCity)
          }
        }
      }, [_c('div', {
        class: [key == item.Citys.length - 1 ? 'cityTdLast' : 'cityTd' ]
      }, [_vm._v("\n                  " + _vm._s(itemCity.CityName) + "\n                ")])])
    }), _vm._v(" "), _c('div', {
      staticClass: "divDivider"
    })], 2)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'tabSecond') ? _c('div', _vm._l((_vm.overSeaCityByLetter), function(item) {
    return _c('div', {
      staticClass: "letterCity"
    }, [(item.Citys.length > 0) ? _c('div', [_c('mu-sub-header', {
      staticClass: "title",
      attrs: {
        "id": 'anchor-' + item.Letter
      }
    }, [_vm._v(_vm._s(item.Letter))]), _vm._v(" "), _vm._l((item.Citys), function(itemCity, key) {
      return _c('div', {
        staticClass: "cityTr",
        on: {
          "click": function($event) {
            return _vm.handleCitychange(itemCity)
          }
        }
      }, [_c('div', {
        class: [key == item.Citys.length - 1 ? 'cityTdLast' : 'cityTd' ]
      }, [_vm._v("\n                  " + _vm._s(itemCity.CityName) + "\n                ")])])
    }), _vm._v(" "), _c('div', {
      staticClass: "divDivider"
    })], 2) : _vm._e()])
  }), 0) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a6617fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/selectCity.vue
// module id = 1472
// module chunks = 18